import mainStyle from "./mainStyle.module.scss";
import { ReactComponent as CheckBoxDefault } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckBoxFilled } from "assets/images/icons/checkbox_fiilled.svg";
import { ReactComponent as CheckBoxClear } from "assets/images/icons/checkbox_clear.svg";

import icn_btn_rediscover from "assets/images/icons/icn_btn_rediscover.svg";
import btn_locked from "assets/images/icons/btn_Locked.svg";
import btn_unlocked from "assets/images/icons/btn_Unlock_hover.svg";

import { Box, Checkbox } from "@mui/material";

import { getDefaultCheckboxProp } from "../theme";
import { authStateOption } from "./const";

const addDeviceColumns = (
  columnHelper,
  disableCheckbox,
  toggleDeviceSelection,
  devices,
  toggleAllDeviceSelection,
) => {
  const checkedCount = devices.filter((device) => device.checked).length;
  const checkedDevice = devices.find((device) => device.checked);
  const sameAuthDevices = checkedDevice
    ? devices.filter((device) => device.authStatus === checkedDevice.authStatus && !disableCheckbox(device))
    : [];
  const isAllChecked = checkedCount > 0 && sameAuthDevices.length > 0 && checkedCount === sameAuthDevices.length;

  return [
    columnHelper.accessor("checkbox", {
      id: "checkbox",
      size: 50,
      enableSorting: false,
      header: () => {
        if (checkedCount === 0) {
          return null;
        }

        return (
          <Box display="flex" alignItems="center" justifyContent="center" style={{ width: "100%", marginLeft: "-6px" }}>
            <Checkbox
              icon={
                <CheckBoxDefault
                  style={{ width: "24px", height: "24px" }}
                />
              }
              indeterminateIcon={
                <CheckBoxClear
                  style={{ width: "24px", height: "24px" }}
                />
              }
              checkedIcon={
                <CheckBoxFilled
                  style={{ width: "24px", height: "24px" }}
                />
              }
              checked={isAllChecked}
              indeterminate={!isAllChecked && checkedCount > 0}
              disabled={sameAuthDevices.length === 0}
              onMouseDown={(event) => event.preventDefault()}
              onPointerDown={(event) => event.stopPropagation()}
              onClick={(event) => event.stopPropagation()}
              onChange={(event, checked) => {
                event.stopPropagation();
                toggleAllDeviceSelection(checked);
              }}
              sx={{ ...getDefaultCheckboxProp().sx }}
            />
          </Box>
        );
      },
      cell: (info) => {
        const device = info.row.original;

        return (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Checkbox
              edge="start"
              icon={
                <CheckBoxDefault
                  style={{ width: "24px", height: "24px" }}
                />
              }
              checkedIcon={
                <CheckBoxFilled
                  style={{ width: "24px", height: "24px" }}
                />
              }
              checked={device.checked}
              disabled={disableCheckbox(device)}
              onClick={(event) => event.stopPropagation()}
              onChange={() => toggleDeviceSelection(device.deviceId)}
              sx={{ ...getDefaultCheckboxProp().sx }}
            />
          </Box>
        );
      },
    }),
    columnHelper.accessor("status.value", {
      id: "status",
      header: "Status",
      size: "100",
      cell: (info) => {
        const device = info.row.original;

        return (
          <Box display="flex" alignItems="center">
            <Box className={`${mainStyle["chip-name"]} ${mainStyle[`${device.status.value}-chip`]}`}>
              {device.status.label}
            </Box>
          </Box>
        );
      },
    }),
    columnHelper.accessor("authStatus", {
      id: "authStatus",
      header: "Auth",
      cell: (info) => {
        const device = info.row.original;

        return (
          <>
            {device.authStatus === null && (
              <img
                src={icn_btn_rediscover}
                alt=""
                style={{ width: "20px", height: "20px", marginRight: "5px" }}
              />
            )}
            {device.authStatus === authStateOption.passed && (
              <img
                src={btn_unlocked}
                alt=""
                style={{ width: "20px", height: "20px", marginRight: "5px" }}
              />
            )}
            {device.authStatus === authStateOption.failed && (
              <img
                src={btn_locked}
                alt=""
                style={{ width: "20px", height: "20px", marginRight: "5px" }}
              />
            )}
          </>
        );
      },
    }),
    columnHelper.accessor("modelName", {
      header: "Model Name",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("deviceId", {
      header: "MAC Address",
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("ipAddress", {
      header: "IP Address",
      cell: (info) => info.getValue(),
    }),
  ];
};

export default addDeviceColumns;
